import {useMutation, useQueryClient} from '@tanstack/react-query'
import {addValid} from '../../../../store/message'
import {useActionDispatch} from '../../../utils'
import {UserFriendlyError} from '../../../../model/Error'

import type {TrustedSource} from "../../../../model/TrustedSource";
import {trustedSourceKeys} from "./trustedSource.keys";
import {postTrustedSource} from "../../../../data/admin/trustedSources/postTrustedSource";

export const usePostTrustedSource = () => {
  const valid = useActionDispatch(addValid)
  const queryClient = useQueryClient()

  const queryReturn = useMutation({
    mutationFn: async (variable: TrustedSource) => {
      if (!variable?.value) {
        throw new UserFriendlyError('error', "Veuillez renseigner une valeur à ajouter")
      }
      const {data, ok, status} = await postTrustedSource(variable)
      if (status === 409) {
        throw new UserFriendlyError('error', 'Une pièce justificative existe déjà avec cette valeur')
      }

      if (!data || !ok) {
        throw new UserFriendlyError('error', 'La création de cette pièce justificative a échoué')
      }

      return data
    },

    onSuccess: () => {
      valid('La pièce justificative a été créé')
      queryClient.refetchQueries({queryKey: trustedSourceKeys.all})
    },
  })
  return queryReturn
}
